
import { authorizationType } from '#authorization/constants';
import { avlType } from '#avl/constants';
import { delistingType } from '#delisting/constants';
import { detailsType } from '#details/constants';
import { photographType } from '#photographs/constants';
import { priorTrxauthzType } from '#trxauth.prior/constants';
import { trxauthzType } from '#trxauth/constants';
import { EnvConfig } from 'apprise-frontend-core/env';
import { XlsxParserConfig, defaultParserConfig } from 'apprise-frontend-parse/context';
import { UIConfig } from 'apprise-ui/context';




export const env: Partial<EnvConfig> & { releaseTrain?: string } = {

    name: window.APPRISE_ENV?.NAME,
    version: window.APPRISE_ENV?.VERSION,
    releaseTrain: import.meta.env.RELEASE_TRAIN

}

export const ui: Partial<UIConfig> = {

    fileLimitSize: 20
}

export const xlsxConfig : Partial<XlsxParserConfig> = {

     ...defaultParserConfig,

    excludeSheet: ['example', 'exemple', 'conseils', 'exemple', 'rav example', 'non-rav example', 'codes','exemple rna', 'exemple non-rna'],
    headerCornerstone: ['entry_#', '#', 'entrée_#'],
    headerCornerstoneColOffset: 1,

    keys: {

        'iotc_record': { tkey: 'parse.uvi', key: 'uvi', colAliases: 'numéro_de_registre' }
    }

    ,

    type: {

        [detailsType]: {

            keys: {

                'record_kind': { tkey: 'parse.kind', key: 'kind', colAliases: 'type_de_registre' },
                'vessel_name': { tkey: 'parse.name', key: 'name', colAliases: 'nom_du_navire' },
                'imo_number': { tkey: 'parse.imo', key: 'imo', colAliases: 'numéro_omi' },
                'national_vessel': { tkey: 'parse.regno', key: 'regno', colAliases: ['numéro_national', 'nnuméro_national', 'numéro_d\'immatriculation_national'] },
                'international_radio': { tkey: 'parse.ircs', key: 'ircs', colAliases: ['indicatif_radio_international','indicatif_d\'appel_radio_international'] },
                'area_of_operation': { tkey: 'parse.range', key: 'range', colAliases: 'zone_d\'activité' },
                'vessel_type': { tkey: 'parse.type', key: 'type', colAliases: 'type_de_navire' },
                'gear_used': { tkey: 'parse.gear', key: 'gear', colAliases: 'engin_utilisé' },
                'port_of_registration': { tkey: 'parse.port', key: 'portname', colAliases: 'port_d\'immatriculation' },
                'vessel_loa': { tkey: 'parse.loa', key: 'loa', colAliases: ['lht_du_navire', 'longueur_hors_tout_du_navire'] },
                'vessel_tonnage': { tkey: 'parse.tonnage', key: 'tonnage', colAliases: 'tonnage_du_navire' },
                'total_volume_of': { tkey: 'parse.volume', key: 'volume', colAliases: 'volume_total' },
                'name_of_owner': { tkey: 'parse.owner', key: 'owner', colAliases: 'nom_du_propriétaire' },
                'address_of_owner': { tkey: 'parse.ownerAddress', key: 'ownerAddress', colAliases: 'adresse_du_propriétaire' },
                'name_of_operator': { tkey: 'parse.operator', key: 'operator', colAliases: ['nom_de_l\'opérateur','nom_de_l\'exploitant'] },
                'address_of_operator': { tkey: 'parse.operatorAddress', key: 'operatorAddress', colAliases: ['adresse_de_l\'opérateur','adresse_de_l\'exploitant'] },
                'name_of_beneficial': { tkey: 'parse.beneficial', key: 'beneficial', colAliases: 'nom_du_bénéficiaire_effectif' },
                'address_of_beneficial': { tkey: 'parse.beneficialAddress', key: 'beneficialAddress', colAliases: 'adresse_du_bénéficiaire_effectif' },
                'name_of_company': { tkey: 'parse.company', key: 'company', colAliases: 'nom_de_la_société' },
                'address_of_company': { tkey: 'parse.companyAddress', key: 'companyAddress', colAliases: 'adresse_de_la_société' },
                'registration_number_of': { tkey: 'parse.companyRegno', key: 'companyRegno', colAliases: 'numéro_d\'immatriculation_de_la_société' },
                'previous_name': { tkey: 'parse.prevName', key: 'previousName', colAliases: 'nom(s)_précédent(s)_du_navire' },
                'previous_flag': { tkey: 'parse.prevFlag', key: 'previousFlag', colAliases: 'pavillon(s)_précédent(s)_du_navire' },
                'details_of_previous_registry_deletions': { tkey: 'parse.prevRegistryDeletions', key: 'previousDeletion', colAliases: 'détails_des_suppressions_précédentes' }

            }

        }

        ,

        [authorizationType]: {

            keys: {

                'period_of_authorisation_from': { tkey: 'parse.from', key: 'from', colAliases: 'période_d\'autorisation_de' },
                'period_of_authorisation_to': { tkey: 'parse.to', key: 'to', colAliases: 'période_d\'autorisation_à' }

            }
        }

        ,


        [trxauthzType]: {

            keys: {

                'type_of': { tkey: 'parse.trxtype', key: 'type', colAliases: 'type_d\'autorisation' },
                'authorised_from': { tkey: 'parse.from', key: 'from', colAliases: 'autorisé_du' },
                'authorised_to': { tkey: 'parse.to', key: 'to', colAliases: 'autorisé_au' },
                // 'revoke': { tkey: 'parse.trxrevoke', key: 'revoke', colAliases: 'révoquer' }

            }
        }

        ,

        [priorTrxauthzType]: {

            keys: {

                'authorised_from': { tkey: 'parse.from', key: 'from', colAliases: 'autorisé_du' },
                'authorised_to': { tkey: 'parse.to', key: 'to', colAliases: 'autorisé_au' },
                'authorisation_number': { tkey: 'parse.number', key: 'number', colAliases: 'numéro_d\'autorisation' },
                'authorising_entity': { tkey: 'parse.entity', key: 'entity', colAliases: 'entité_autorisante' },
                // 'revoke': { tkey: 'parse.trxrevoke', key: 'revoke', colAliases: 'révoquer' }

            }
        }

        ,


        [delistingType]: {

            keys: {

                reason: { tkey: 'parse.delisttype', key: 'reason', colAliases: 'motif' },
                note: { tkey: 'parse.delistnote', key: 'note', colAliases: 'note' },
                date: { tkey: 'parse.delistdate', key: 'date', colAliases: 'date_de_radiation' }


            }
        }

        ,

        [photographType]: {

            keys: {

                'starboard_side_of_the_vessel': { tkey: 'parse.starboard', key: 'starboard', colAliases: 'côté_tribord' },
                'portside_of_the_vessel': { tkey: 'parse.portside', key: 'portside', colAliases: 'côté_bâbord' },
                'bow_of_the_vessel': { tkey: 'parse.bow', key: 'bow', colAliases: 'proue' }

            }
        },

        [avlType]: {
            keys: {
                'main_target_species': { tkey: 'parse.species', key: 'species', colAliases: 'principales_espèces' },
                'active_in_year': { tkey: 'parse.year', key: 'year', colAliases:'année d\'activité'},
                'name_of_charterer': { tkey: 'parse.charterer_name', key: 'chartererName', colAliases: 'nom_de_l\'affréteur'},
                'address_of_charterer': { tkey: 'parse.charterer_address', key: 'chartererAddress', colAliases: 'adresse_de_l\'affréteur'}
            },

            allowMissingColumn: true
        }

    }

}
